export function orgNrValidator(orgnr: string): boolean {
  if (!/^\d{9}$/.test(orgnr)) return false;

  const weights = [3, 2, 7, 6, 5, 4, 3, 2];
  let sum = 0;
  for (let i = 0; i < 8; i++) sum += Number(orgnr[i]) * weights[i];

  const remainder = sum % 11;
  const control = remainder === 0 ? 0 : 11 - remainder;

  if (control === 11) return false;
  return control === Number(orgnr[8]);
}

export function namesValidator(name: string): boolean {
  return name.replace(/\s/g, "").length >= 1;
}

export function emailValidator(email: string): boolean {
  return email.match(".*\\@.*") !== null;
}
